import '../styles/ProductsWithChart.scss'

const Bricks = () => {
    return (
        <div className="container">
            <h1>Bricks and Blocks</h1>
            <h3>IDEAL FOR NUCEAR AND MEDICAL RADIATION SHIELDING AND AS COUNTER-WEIGHTS</h3>
            <p>Our standard sizes are listed below and custom sizes are available upon request.</p>
            <table className='main-table'>
                <tr>
                <th>SIZE</th>
                <th>APPROX WEIGHT</th>
                </tr>
                <tr>
                    <td className='odd-row'>2" X 3" X 6"</td>
                    <td className='odd-row'>14.73 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 76.2mm X 152.4mm</td>
                    <td className='even-row'>6.88 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>2" X 3" X 8"</td>
                    <td className='odd-row'>19.64 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 76.2mm X 203.2mm</td>
                    <td className='even-row'>8.91 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>2" X 3" X 10"</td>
                    <td className='odd-row'>24.55 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 76.2mm X 254.0mm</td>
                    <td className='even-row'>11.14 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>2" X 3" X 12"</td>
                    <td className='odd-row'>29.46 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 76.2mm X 304.8mm</td>
                    <td className='even-row'>13.36 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>2" X 4" X 6"</td>
                    <td className='odd-row'>19.4 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 101.6mm X 152.4mm</td>
                    <td className='even-row'>8.81 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>2" X 4" X 8"</td>
                    <td className='odd-row'>26.19 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 101.6mm X 203.2mm</td>
                    <td className='even-row'>11.88 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>2" X 4" X 10"</td>
                    <td className='odd-row'>32.74 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 101.6mm X 254.0mm</td>
                    <td className='even-row'>14.85 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>2" X 4" X 12"</td>
                    <td className='odd-row'>39.28 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 101.6mm X 304.8mm </td>
                    <td className='even-row'>17.82 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>2" X 5" X 6"</td>
                    <td className='odd-row'>24.55 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 127mm X 152.4mm</td>
                    <td className='even-row'>11.14 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'> 2" X 5" X 8"</td>
                    <td className='odd-row'>32.47 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 127mm X 203.2mm</td>
                    <td className='even-row'>14.85 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>2" X 5" X 10"</td>
                    <td className='odd-row'>40.92 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 127mm X 254.0mm</td>
                    <td className='even-row'>18.56 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>2" X 5" X 12"</td>
                    <td className='odd-row'>49.10 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>50.8mm X 127mm X 304.8mm</td>
                    <td className='even-row'>22.27 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>3" X 4" X 6"</td>
                    <td className='odd-row'>29.46 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>76.2mm X 101.6mm X 152.4mm</td>
                    <td className='even-row'>13.36 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>3" X 4" X 8"</td>
                    <td className='odd-row'>39.28 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>76.2mm X 101.6mm X 203.2mm</td>
                    <td className='even-row'>17.82 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>3" X 4" X 10"</td>
                    <td className='odd-row'>49.10 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>76.2mm X 101.6mm X 254.0mm</td>
                    <td className='even-row'>22.27 kg</td>
                </tr>
                <tr>
                    <td className='odd-row'>3" X 4" X 12"</td>
                    <td className='odd-row'>58.92 lbs</td>
                </tr>
                <tr>
                    <td className='even-row'>76.2mm X 101.6mm X 304.8mm</td>
                    <td className='even-row'>26.73 kg</td>
                </tr>

            </table>
        </div>
    );
};

export default Bricks;